<template>
  <div class="direction-details" v-if="selected_order">
    <order-instructions :order="selected_order" />
    <div class="media">
      <img src="/images/svg/checkout/location.svg" alt="" />
      <div class="media-body">
        <h5 v-if="store">
          <RestaurantAddress :address="store" />
        </h5>
        <h5 v-else>
          {{ _T('No address found') }}
        </h5>
      </div>
    </div>
    <div class="location-map">
      <iframe
        width="300"
        height="170"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        :src="
          `https://maps.google.com/maps?q=${store.location_coordinates.lat},${
            store.location_coordinates.lng
          }&hl=an&z=14&amp;output=embed`
        "
      >
      </iframe>
    </div>
    <button
      type="button"
      @click.prevent="trackOrder"
      class="btn btn-solid btn-block"
    >
      {{ _T('Get Direction') }}
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RestaurantAddress from '@/components/Blocks/Util/RestaurantAddress'
export default {
  name: 'OrderDirections',
  props: {
    store: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters(['_T', 'selected_order', 'brandStoreRoute', 'currentStoreSlug', 'currentBrandSlug']),
  },
  methods: {
    trackOrder() {
      this.$router.replace({
        name: this.brandStoreRoute('track-order'),
        params: {
          brand_id: this.currentBrandSlug || this.selected_order.brand_id,
          store_id: this.currentStoreSlug || this.selected_order.store_id,
          order_id: this.selected_order._id,
        },
      })
    },
  },
  components: {
    RestaurantAddress,
    OrderInstructions: () => import('./OrderInstructions'),
  },
}
</script>

<style lang="scss" scoped>
.delivery-order {
  .direction-details {
    padding: $px20 0 $px40;
    border-top: $px1 dashed $light-border;

    /deep/.location-map {
      margin-bottom: $px20;

      iframe {
        height: $px154;
        width: 100%;
        border: $px2 solid $white;
        box-shadow: 0px 5px 23px rgba($black, 0.09);
        border-radius: $px8;
      }
    }
  }
}
.dine-in-details {
  .direction-details {
    .media {
      .media-body {
        padding-left: $px16;
      }
    }
  }
}

.btn-solid {
  background: $color-primary;
  color: $white;
  transition: all 0.5s ease;
  cursor: pointer;
}

.btn-solid:hover,
.btn-solid:focus {
  color: $color-primary;
  background: $white;
  border-color: $color-primary;
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
</style>
